import { gql } from '@apollo/client'

const GET_VIEWERS_ACTIVE_TICKET_ALERTS = gql`
  query getViewersActiveTicketAlerts {
    viewer {
      id
      activeTicketAlerts {
        event {
          id
        }
        eventType {
          id
        }
      }
    }
  }
`

export default GET_VIEWERS_ACTIVE_TICKET_ALERTS
